import * as d3 from "d3";

const parseDate = d3.timeParse("%m/%d/%Y");

export function draw(container, data, config) {
  const cwidth = container.clientWidth;
  const cheight = container.clientHeight;

  const { axes, header, layout, svg: svgx } = config;

  const marginBottom = layout.margin.bottom;
  const marginLeft = layout.margin.left;

  const svg = d3.select(container);
  svg.selectAll("g").remove();

  if (data) {
    /** d3 margin convention */
    const width = cwidth - marginLeft - layout.margin.right;
    const height = cheight - layout.margin.top - marginBottom;
    /** SVG Styles */
    svg.style("background-color", svgx.Background);
    if (svgx.border) {
      svg.style("border", svgx.border);
    }

    if (header) {
      const headerGroup = svg.append("g");

      headerGroup
        .append("text")
        .attr("y", header.margin.top)
        .attr("x", header.margin.left)
        .attr("fill", header.colour)
        .style("text-anchor", "left")
        .style("font-size", header.fontSize)
        .style("font-weight", header.fontWeight)
        .text(header.text)
        .append("tspan")
        .attr("fill", "blue")
        .html("Vector")
        .append("tspan")
        .attr("fill", header.colour)
        .html(" and ")
        .append("tspan")
        .attr("fill", "red")
        .html("Sigma")
        .append("tspan")
        .attr("fill", header.colour)
        .html("  model based Var and OaR");
    }

    const layoutGroup = svg
      .append("g")
      .attr(
        "transform",
        "translate(" + marginLeft + "," + layout.margin.top + ")"
      );

    const fields = [
      { name: "Sigma_95D", field: "Sigma_95D", stroke: "#FF9DA7", plus: true },
      { name: "Sigma_95U", field: "Sigma_95D", stroke: "#FF9DA7", plus: false },
      { name: "Sigma_99D", field: "Sigma_99D", stroke: "#E15759", plus: true },
      { name: "Sigma_99U", field: "Sigma_99D", stroke: "#E15759", plus: false },
      { name: "Vector_99U", field: "99U", stroke: "#2A5783", plus: true },
      { name: "Vector_99D", field: "99D", stroke: "#2A5783", plus: true },
      { name: "Vector_95U", field: "95U", stroke: "#AFD6ED", plus: true },
      { name: "Vector_95D", field: "95D", stroke: "#AFD6ED", plus: true },
    ];

    const linedata = fields.map((item) => {
      return {
        name: item.name,
        stroke: item.stroke,
        strokeWidth: 3,
        values: data
          .filter((f) => {
            return parseDate(f.ModelDate) !== null;
          })
          .map((d) => {
            return {
              date: parseDate(d.ModelDate),
              val: item.plus
                ? (1 + +d[item.field].replace("%", "") / 100) * +d.Px
                : (1 - +d[item.field].replace("%", "") / 100) * +d.Px,
            };
          }),
      };
    });

    const lineGroup = layoutGroup.append("g");

    const xScale = d3
      .scaleTime()
      .domain(
        d3.extent(
          linedata.reduce((a, b) => {
            return (a = a.concat(b.values));
          }, []),
          (d) => d.date
        )
      )
      .range([0, width]);

    const yScale = d3
      .scaleLinear()
      .domain(
        d3.extent(
          linedata.reduce((a, b) => {
            return (a = a.concat(b.values));
          }, []),
          (d) => d.val
        )
      )
      .range([height, 0]);

    const line = d3
      .line()
      .x((d) => xScale(d.date))
      .y((d) => yScale(d.val));

    lineGroup
      .selectAll(".line-group")
      .data(linedata)
      .enter()
      .append("g")
      .attr("class", "line-group")
      .append("path")
      .attr("class", "line")
      .attr("d", (d) => {
        return line(d.values);
      })
      .style("stroke", (d, i) => d.stroke)
      .style("stroke-width", (d, i) => d.strokeWidth)
      .style("fill", "none");

    /* Add Axis into SVG */
    var xAxis = d3
      .axisBottom(xScale)
      .ticks(5)
      .tickSizeInner(axes.x.tickSizeInner);
    var yAxis = d3
      .axisLeft(yScale)
      .ticks(5)
      .tickSizeInner(axes.y.tickSizeInner);

    svg
      .append("g")
      .attr("class", "x axis")
      .attr(
        "transform",
        `translate(${marginLeft}, ${height + layout.margin.top})`
      )
      .call(xAxis);

    if (axes.y.show) {
      svg
        .append("g")
        .attr("class", "y axis")
        .call(yAxis)
        .attr("transform", `translate(${marginLeft}, ${layout.margin.top})`);
    }

    svg.selectAll(".x .domain").style("stroke", axes.x.domainColour);
    svg.selectAll(".x .tick line").style("stroke", axes.x.tickLineColour);
    svg.selectAll(".x .tick text").style("fill", axes.x.textColour);
    svg.selectAll(".y .domain").style("stroke", axes.y.domainColour);
    svg.selectAll(".y .tick line").style("stroke", axes.y.tickLineColour);
    svg.selectAll(".y .tick text").style("fill", axes.y.textColour);
  }
}
